export default {
  thesun: ['thesun-ie', 'thesun-us', 'thesun-za', 'thesun-aus', 'thesun-ng'],
  talksport: ['talksport-ie', 'talksport-us', 'talksport-za', 'talksport-aus', 'talksport-ng'],
};
